import * as React from "react";
import { useEffect } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import { toast, ToastContainer } from "react-toastify";

import ShareIcon from '@mui/icons-material/Share';
import { Box, Button, Grid, Stack, Tab, Typography, } from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";

import Divider from "@mui/material/Divider";
import MediaControlCard from "./cards";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { DraftApi } from "../../../APIConfig/CtfConfig";
import truncateString from "../../../utilities/truncateString";
import { downloadReport, getReportList, } from "../../../APIConfig/version2Scenario";
import ApiVersion2 from "../../../APIConfig/version2Api";
import ErrorHandler from "../../../ErrorHandler";

export const generateReportPDF = async (actScenId, userId) => {
    try {
        const data = await downloadReport(actScenId, userId);
        if (data) {
            const downloadLink = document.createElement("a");
            downloadLink.href = `${process.env.REACT_APP_API_PATH}/${ApiVersion2?.scenario?.newDownloadReport}${actScenId}/${userId}/`;
            downloadLink.download = "report.pdf";
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
        }
    } catch (error) {
        ErrorHandler(error);
    }
};

const PlayerProfile = () => {
    const user_Id = useParams()
    const [loading, setLoading] = React.useState(false)
    const [user, setUser] = React.useState()
    const [isError, setError] = React.useState(false)
    const location = useLocation();
    const navigate = useNavigate();
    const hide = location?.state?.hide;
    const MAX_CHAR_LENGTH = 15;
    const [value, setValue] = React.useState("1");
    const [draft, setDraft] = React.useState([]);
    const [reportData, setReportData] = React.useState();
    const parsedUserId = user_Id?.userId;
    const handleTabChange = (event, newValue) => {
        setValue(newValue);
    };
    useEffect(() => {
        const parseJson = (raw) => {
            try {
                return raw ? JSON.parse(raw) : null;
            } catch (_e) {
                return null;
            }
        };

        const normalizeUser = (u) => {
            if (!u) return null;

            // Already in expected "winning wall" shape
            if (u.user_id || u.user_full_name) {
                return {
                    ...u,
                    user_id: u.user_id ?? u.id,
                    user_full_name: u.user_full_name ?? u.full_name ?? u.username ?? "",
                    user_avatar:
                        u.user_avatar ??
                        u.avatar?.image_url ??
                        u.avatar?.url ??
                        "",
                    user_role: u.user_role ?? u.team ?? "",
                    user_ctf_score: u.user_ctf_score ?? 0,
                    user_scenario_score: u.user_scenario_score ?? 0,
                    user_corporate_score: u.user_corporate_score ?? 0,
                };
            }

            // Normalize `cyberrange_user` stored profile (auth/me payload).
            return {
                user_id: u.id,
                user_full_name: u.full_name || `${u.first_name || ""} ${u.last_name || ""}`.trim() || u.username || "",
                user_avatar: u.avatar?.image_url || u.avatar?.url || "",
                user_role: u.team || "",
                is_admin: Boolean(u.is_admin || u.is_staff),
                user_ctf_score: u.user_ctf_score ?? 0,
                user_scenario_score: u.user_scenario_score ?? 0,
                user_corporate_score: u.user_corporate_score ?? 0,
                ctf_played: u.ctf_played ?? [],
                ctf_created: u.ctf_created ?? [],
            };
        };

        // Priority: route state -> selected profile cache -> signed-in profile cache.
        const stateUser =
            location?.state?.userData ||
            location?.state?.the || // older sidebar link shape
            null;
        const cachedSelectedUser = parseJson(localStorage.getItem(`player_profile_${parsedUserId}`));
        const loggedInUser = parseJson(localStorage.getItem("cyberrange_user")) || parseJson(localStorage.getItem("user"));

        const resolvedUser = normalizeUser(stateUser) || normalizeUser(cachedSelectedUser) || normalizeUser(loggedInUser);

        if (resolvedUser) {
            setUser(resolvedUser);
            setError(false);
        } else {
            setError(true);
        }
    }, [location?.state, parsedUserId]);


    // useEffect(() => {


    //     const getData = async () => {
    //         try {
    //             const response = await DraftApi();
    //             response?.data && setDraft(response?.data);
    //         } catch (error) {
    //             ErrorHandler(error);
    //         }
    //     };
    //     getData();
    // }, [user?.user_id]);


    const getReportData = async () => {
        if (user?.user_id) {
            try {
                const data = await getReportList(user?.user_id);
                if (data) {
                    setReportData(data?.data);
                }
            } catch (error) {
                ErrorHandler(error);
            }
        }
    };

    const machineSubmittedHeading = [
        { title: "Machine Name", align: "left" },
        { title: "Category", align: "left" },
        { title: "Flags", align: "center" },
        { title: "Solved By", align: "right" },
    ];
    const ctfPlayedHeading = [
        { title: "Machine Name", align: "left" },
        { title: "Category", align: "left" },
        { title: "Flags", align: "center" },
        { title: "Date", align: "center" },
        { title: "Status", align: "right" },
    ];
    const draftHeading = [
        { title: "Machine Name", align: "left" },
        { title: "Category", align: "left" },
        { title: "Flags", align: "center" },
        { title: "Solved By", align: "center" },
        { title: "Submit File", align: "right" },
    ];
    const reportHeading = [
        { title: "S.No", align: "left" },
        { title: "Corporate Name", align: "left" },
        { title: "Corporate Type", align: "center" },
        { title: user?.is_admin ? "participant" : "Score", align: "center" },
        { title: "Download Report", align: "right" },
    ];

    const userColumn = [
        {
            img: user?.user_avatar,
            name: user?.user_full_name,
            aboutUser:
                "Just one more game. Sleep. Eat. Game. Repeat. A gamer truly loves you when he offers to teach you how to play. How to talk to someone when they’re gaming: Don’t. When you finish a game, you don’t know what to do anymore, play again.",
            // score: user.user_ctf_score,
            solo: user?.user_ctf_score,
            Squad: user?.user_scenario_score,
            Corporate: user?.user_corporate_score,
            // totalLikes: 2345,
        },
    ];
    const badgesBeginner = [
        {
            img: "https://st3.depositphotos.com/8950810/17657/v/450/depositphotos_176577870-stock-illustration-cute-smiling-funny-robot-chat.jpg",
            name: "rishav",
            aboutUser: "Lorem ipsum dolor sit amet consectetur.",
        },
        {
            img: "https://st3.depositphotos.com/8950810/17657/v/450/depositphotos_176577870-stock-illustration-cute-smiling-funny-robot-chat.jpg",
            name: "rishav",
            aboutUser: "Lorem ipsum dolor sit amet consectetur.",
        },
        {
            img: "https://st3.depositphotos.com/8950810/17657/v/450/depositphotos_176577870-stock-illustration-cute-smiling-funny-robot-chat.jpg",
            name: "rishav",
            aboutUser: "Lorem ipsum dolor sit amet consectetur.",
        },
        {
            img: "https://st3.depositphotos.com/8950810/17657/v/450/depositphotos_176577870-stock-illustration-cute-smiling-funny-robot-chat.jpg",
            name: "rishav",
            aboutUser: "Lorem ipsum dolor sit amet consectetur.",
        },
    ];


    if (isError) return <Stack sx={{ margin: 4, borderRadius: 3 }} height='80vh' direction="row" mb={4} alignItems="center" justifyContent='center'>
        <Typography variant="h4">
            User Not Found
        </Typography>
        <ToastContainer />
    </Stack>

    const shareProfileUrl = () => {
        const currentUrl = window.location.href;

        // Check if the Web Share API is supported
        if (navigator.share) {
            navigator.share({
                title: `${user?.user_full_name || 'User'}'s Profile`,
                text: `Check out ${user?.user_full_name || 'this user'}'s profile on our platform`,
                url: currentUrl,
            })
                .then(() => console.log('Profile shared successfully'))
                .catch((error) => console.log('Error sharing profile:', error));
        } else {
            // Fallback: Copy to clipboard
            navigator.clipboard.writeText(currentUrl)
                .then(() => {
                    toast.success('Profile URL copied to clipboard!');
                })
                .catch((error) => {
                    console.error('Failed to copy URL to clipboard:', error);
                    toast.error('Failed to copy URL to clipboard');

                    // Alternative fallback: show URL in alert
                    alert(`Share this profile URL:\n${currentUrl}`);
                });
        }
    };


    return (
        <Stack sx={{ margin: 4, borderRadius: 3 }}>
            <ToastContainer />
            <Stack direction="row" mb={4} alignItems="center">
                <Stack gap={2} width="100%">
                    {userColumn.map((user) => {
                        return (
                            <Stack
                                direction="row"
                                sx={{
                                    backgroundColor: "custom.main",
                                    py: 5,
                                    px: 1.5,
                                    width: "100%",
                                    borderRadius: "16px",
                                    gap: 5,
                                }}
                            >

                                <Stack
                                    direction="row"
                                    justifyContent={"space-between"}
                                    sx={{
                                        backgroundColor: "custom.secondary",
                                        width: "100%",
                                        borderRadius: "16px",
                                        alignItems: "center",
                                        padding: 5,
                                    }}
                                >


                                    <Stack
                                        direction="row"
                                        justifyContent="left"
                                        alignItems="center"
                                    >
                                        <img
                                            src={user?.img}
                                            style={{
                                                width: "72px",
                                                height: "72px",
                                                borderRadius: "50%",
                                            }}
                                        />
                                        <Stack ml={2}>
                                            <Stack direction='row' justifyContent='space-between' alignItems='center'>

                                                <Typography variant="h1">
                                                    {truncateString(user?.name, MAX_CHAR_LENGTH)}

                                                </Typography>
                                                <ShareIcon
                                                    sx={{
                                                        cursor: 'pointer',
                                                        '&:hover': {
                                                            color: '#00CCCC',
                                                            transform: 'scale(1.1)'
                                                        },
                                                        transition: 'all 0.2s ease-in-out'
                                                    }}
                                                    color="error"
                                                    onClick={shareProfileUrl} />
                                            </Stack>
                                            <Typography variant="body1">{user?.aboutUser}</Typography>


                                        </Stack>
                                    </Stack>
                                </Stack>


                                <Stack sx={{ width: "100%", direction: "column", }}>
                                    <Stack
                                        direction="row"
                                        justifyContent="space-evenly"
                                        sx={{
                                            backgroundColor: "custom.secondary",
                                            width: "100%",
                                            borderRadius: "16px",
                                            // alignItems: "center",
                                            padding: 12,
                                            border: "1px solid #b46228",
                                            mb: 2,
                                        }}
                                    >
                                        <Stack
                                            direction="column"
                                            sx={{ alignItems: "center" }}
                                            gap={2}
                                        >
                                            <Typography variant="body1">Solo</Typography>
                                            {user?.solo ? (
                                                <Typography fontSize="32px" color="#b46228">
                                                    {user?.solo}
                                                </Typography>
                                            ) : (
                                                <Typography fontSize="32px" color="#b46228">
                                                    0
                                                </Typography>
                                            )}
                                        </Stack>

                                        <Divider
                                            orientation="vertical"
                                            variant="middle"
                                            flexItem
                                            color="#f4f4f4"
                                            sx={{ height: "100%" }}
                                        />
                                        <Stack
                                            direction="column"
                                            sx={{ alignItems: "center" }}
                                            gap={2}
                                        >
                                            <Typography variant="body1">Squad</Typography>
                                            {user?.Squad ? (
                                                <Typography fontSize="32px" color="#b46228">
                                                    {user?.Squad}
                                                </Typography>
                                            ) : (
                                                <Typography fontSize="32px" color="#b46228">
                                                    0
                                                </Typography>
                                            )}
                                        </Stack>
                                        <Divider
                                            orientation="vertical"
                                            variant="middle"
                                            flexItem
                                            color="#f4f4f4"
                                            sx={{ height: "100%" }}
                                        />
                                        <Stack
                                            direction="column"
                                            sx={{ alignItems: "center" }}
                                            gap={2}
                                        >
                                            <Typography variant="body1">Corporate</Typography>
                                            {user?.Corporate > 0 ? (
                                                <Typography fontSize="32px" color="#b46228">
                                                    {user?.Corporate}
                                                </Typography>
                                            ) : (
                                                <Typography fontSize="32px" color="#b46228">
                                                    0
                                                </Typography>
                                            )}
                                        </Stack>
                                    </Stack>
                                </Stack>
                            </Stack>
                        );
                    })}
                </Stack>
            </Stack>

         
        </Stack >
    );

};

export default PlayerProfile;